import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import BSL_ControlContainer from "./BSL_ControlContainer";
import { Tooltip } from "@material-ui/core";

const BSLCheckbox = withStyles((theme) => ({
    root: {
        color: "white",
        padding: "0px 10px 0px 0px",

        "& .MuiIconButton-label": {
            position: "relative",
            zIndex: 0,
            outline: theme.brand.FIELDERS ? "1px solid #6B8799" : "1px solid " + Palette.Lysaght.DarkBlue,
            outlineOffset: "-1px",
            backgroundColor: "white",
        },

        "& .MuiSvgIcon-root": {
            width: "21px",
            height: "21px",
        },

        "&:focus": {
            "& .MuiIconButton-label": {
                outline: theme.brand.FIELDERS ? "2px solid #6B8799" : "2px solid " + Palette.Lysaght.DarkBlue,
                outlineOffset: "-2px",
            },
        },

        "&$checked": {
            color: theme.brand.FIELDERS ? "white" : Palette.Lysaght.DarkBlue,
            "& .MuiIconButton-label": {
                position: "relative",
                zIndex: 1,
                // border: "1px solid black",
                // outline: '2px solid ' + Palette.Control.FieldersDarkBlue,
                outlineOffset: "-1px",
                backgroundColor: theme.brand.FIELDERS ? "white" : Palette.Lysaght.DarkBlue,
                color: theme.brand.FIELDERS ? "white" : Palette.Lysaght.DarkBlue,
            },
            "& .MuiSvgIcon-root": {
                zIndex: 1,
            },
            "& .MuiIconButton-label:after": {
                content: '""',
                left: 4,
                top: 4,
                height: 13,
                width: 13,
                position: "absolute",
                backgroundColor: theme.brand.FIELDERS ? Palette.Control.FieldersDarkBlue : "white",
                zIndex: 0,
            },
        },
    },
    checked: {},
}))((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        margin: "4px 0px 2px 0px",
    },
    label: {
        cursor: "pointer",
        flex: "1",
        font: (theme.brand.FIELDERS ? "16px " : "14px ") + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        padding: "0px 0px",
        whiteSpace: "normal",
        textAlign: "start",
    },
    subtitle: {
        flex: "1",
        font: "13px 'Univers45', sans-serif",
        color: "#6B8799",
        textAlign: "end",
        padding: "4px 0px",
    },
    helperText: {
        flex: "1",
        font: "13px 'Univers45', sans-serif",
        color: Palette.Control.DarkGrey,
        textAlign: "start",
        padding: "4px 0px",
    },
    input: {
        padding: "2px",
        font: (theme.brand.FIELDERS ? "16px " : "14px ") + theme.typography.fontFamily,
        padding: "10px 8px",
        border: "1px solid #6B8799",
    },
    textField: {
        // root: {
        borderRadius: "0px",
        // }
    },
    notchedOutline: {
        "&:focus": {
            borderWidth: "1px",
            borderColor: "#002D62 !important",
        },
    },
}));

export default function BSL_CheckBox(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <BSL_ControlContainer {...{ ...props, label: props.main_label }}>
            <Tooltip title={props.disabled && props.disabledTooltip ? props.disabledTooltip : ""}>
                <FormControlLabel
                    classes={{ root: classes.root, label: classes.label }}
                    disabled={props.disabled}
                    control={
                        <BSLCheckbox
                            disabled={props.disabled}
                            checked={props?.checked ? true : false}
                            onChange={(e) => {
                                if (props.onChange)
                                    props.onChange(props.returnInt ? (e.target.checked ? 1 : 0) : e.target.checked);
                            }}
                            name={props.checkBoxText}
                        />
                    }
                    label={props.label}
                />
            </Tooltip>
        </BSL_ControlContainer>
    );
}
